// extracted by mini-css-extract-plugin
export var falconContainer = "_vi-2";
export var offerCenter = "_vi-0";
export var roktContainer = "_vi-1";